import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { contactInfo } from '../mock';

const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show button after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip after button appears
      setTimeout(() => setShowTooltip(true), 500);
      // Hide tooltip after 5 seconds
      setTimeout(() => setShowTooltip(false), 5500);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hi! I visited your website and I'm interested in your services. Please provide more information.");
    window.open(`https://wa.me/${contactInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div
        className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 bg-white border border-[var(--border-light)] rounded-xl shadow-lg p-3 w-48 animate-bounce">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-[var(--text-muted)] hover:text-[var(--text-primary)]"
            >
              <X size={14} />
            </button>
            <p className="body-medium text-sm" style={{ color: 'var(--text-body)' }}>
              Need help? Chat with us on WhatsApp!
            </p>
          </div>
        )}

        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsAppClick}
          className="relative w-16 h-16 rounded-full flex items-center justify-center shadow-xl hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-200"
          style={{
            background: '#25D366',
          }}
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle size={32} color="white" strokeWidth={2} />
          
          {/* Pulse animation */}
          <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-30" />
        </button>
      </div>
    </>
  );
};

export default FloatingWhatsApp;
